function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#282828;}.a{fill:#fff;}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 27.49,
  cy: 27.49,
  r: 27.49
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M14.23,23V32h5.89l7.37,7.56V15.39L20.12,23Zm19.9,4.53a6.83,6.83,0,0,0-3.69-6.09V33.57A6.78,6.78,0,0,0,34.13,27.49ZM30.44,14.23v3.11a10.67,10.67,0,0,1,0,20.3v3.12a13.69,13.69,0,0,0,0-26.53Z"
});

const SvgVolume = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 54.99 54.99",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVolume, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/volume.4672b1f9.svg";
export { ForwardRef as ReactComponent };